import 'jquery-scrollify';
import 'jquery.easing';
import {stopNavigating} from './router';

export function toggleScrollify() {
    if (!$.scrollify.isDisabled()) {
        $.scrollify.disable();
    } else {
        $.scrollify.enable();
    }
}

export function configScrollify() {
    $.scrollify({
        section: '.section',
        sectionName: false,
        easing: 'easeOutExpo',
        scrollSpeed: 1100,
        scrollbars: true,
        setHeights: false,
        overflowScroll: true,
        updateHash: false,
        touchScroll: false,
        after: function () {
            stopNavigating();
        }
    });
}

export function destroyScrollify() {
    $.scrollify.destroy();
}



//////////////////
// WEBPACK FOOTER
// ./src/js/scrollify-config.js
// module id = wihg
// module chunks = 0